module.exports = __webpack_public_path__ + "static/media/3.23_preview.ecc8a3d5.png";